import { makeStyles, Theme } from "@material-ui/core/styles";

interface StylesProps {
  riskFactorsWidth: number;
}

const columnsWidth = {
  horseAndTrainer: "180px",
  raceDate: "100px",
  raceNumber: "100px",
  racePosition: "100px",
  raceType: "250px",
  watchList: "110px",
  riskLevel: "100px",
  barn: "100px",
  stall: "100px",
  csa: "100px",
  hsf: "80px",
  dlw: "80px",
  dlr: "80px",
  lastExam: "100px",
  vetLists: "100px",
  risksFactorScore: "140px",
  risksFactors: "120px",
  exam: "120px",
  entryReview: "140px",
  raceDayReview: "140px",
  unAssign: "80px",
  assignedVet: "180px",
  extender: "auto"
};

const getActualRiskFactorsColumnWidth = (riskFactorsWidth: number) => {
  return riskFactorsWidth ? `${riskFactorsWidth}px` : columnsWidth.risksFactors;
};

const getEntriesTabTemplateColumns = ({
  riskFactorsWidth
}: StylesProps): string => `
  ${columnsWidth.horseAndTrainer}
  ${columnsWidth.raceDate}
  ${columnsWidth.raceNumber}
  ${columnsWidth.racePosition}
  ${columnsWidth.raceType}
  ${columnsWidth.lastExam}
  ${columnsWidth.riskLevel}
  ${columnsWidth.watchList}
  ${columnsWidth.barn}
  ${columnsWidth.stall}
  ${columnsWidth.csa}
  ${columnsWidth.hsf}
  ${columnsWidth.dlw}
  ${columnsWidth.dlr}
  ${columnsWidth.vetLists}
  ${columnsWidth.risksFactorScore}
  ${getActualRiskFactorsColumnWidth(riskFactorsWidth)}
  ${columnsWidth.extender}
`;

const getEntryExamsTabTemplateColumns = ({
  riskFactorsWidth
}: StylesProps): string => `
  ${columnsWidth.horseAndTrainer}
  ${columnsWidth.raceDate}
  ${columnsWidth.raceNumber}
  ${columnsWidth.racePosition}
  ${columnsWidth.exam}
  ${columnsWidth.lastExam}
  ${columnsWidth.barn}
  ${columnsWidth.stall}
  ${columnsWidth.raceType}
  ${columnsWidth.watchList}
  ${columnsWidth.assignedVet}
  ${columnsWidth.unAssign}
  ${columnsWidth.riskLevel}
  ${columnsWidth.vetLists}
  ${columnsWidth.risksFactorScore}
  ${columnsWidth.csa}
  ${columnsWidth.hsf}
  ${columnsWidth.dlw}
  ${columnsWidth.dlr}
  ${getActualRiskFactorsColumnWidth(riskFactorsWidth)}
  ${columnsWidth.extender}
`;

const getRaceDayTabTemplateColumns = ({
  riskFactorsWidth
}: StylesProps): string => `
  ${columnsWidth.horseAndTrainer}
  ${columnsWidth.raceDate}
  ${columnsWidth.raceNumber}
  ${columnsWidth.racePosition}
  ${columnsWidth.entryReview}
  ${columnsWidth.exam}
  ${columnsWidth.lastExam}
  ${columnsWidth.barn}
  ${columnsWidth.stall}
  ${columnsWidth.raceType}
  ${columnsWidth.watchList}
  ${columnsWidth.assignedVet}
  ${columnsWidth.unAssign}
  ${columnsWidth.riskLevel}
  ${columnsWidth.vetLists}
  ${columnsWidth.risksFactorScore}
  ${columnsWidth.csa}
  ${columnsWidth.hsf}
  ${columnsWidth.dlw}
  ${columnsWidth.dlr}
  ${getActualRiskFactorsColumnWidth(riskFactorsWidth)}
  ${columnsWidth.extender}
`;

const getRaceDayResultsTabTemplateColumns = ({
  riskFactorsWidth
}: StylesProps): string => `
  ${columnsWidth.horseAndTrainer}
  ${columnsWidth.raceDate}
  ${columnsWidth.raceNumber}
  ${columnsWidth.racePosition}
  ${columnsWidth.raceType}
  ${columnsWidth.raceDayReview}
  ${columnsWidth.riskLevel}
  ${columnsWidth.barn}
  ${columnsWidth.stall}
  ${columnsWidth.csa}
  ${columnsWidth.hsf}
  ${columnsWidth.dlw}
  ${columnsWidth.dlr}
  ${columnsWidth.vetLists}
  ${columnsWidth.risksFactorScore}
  ${getActualRiskFactorsColumnWidth(riskFactorsWidth)}
  ${columnsWidth.extender}
`;

export default makeStyles<Theme, StylesProps | null>({
  rowContentEntries: {
    gridTemplateColumns: getEntriesTabTemplateColumns
  },
  rowContentEntryExams: {
    gridTemplateColumns: getEntryExamsTabTemplateColumns
  },
  rowContentRaceDay: {
    gridTemplateColumns: getRaceDayTabTemplateColumns
  },
  rowContentRaceDayResults: {
    gridTemplateColumns: getRaceDayResultsTabTemplateColumns
  },
  rowContentResults: {
    gridTemplateColumns: `
      ${columnsWidth.horseAndTrainer}
      ${columnsWidth.raceDate}
      ${columnsWidth.raceNumber}
      ${columnsWidth.racePosition}
      ${columnsWidth.raceType}
      ${columnsWidth.entryReview}
      ${columnsWidth.riskLevel}
      ${columnsWidth.barn}
      ${columnsWidth.stall}
      ${columnsWidth.csa}
      ${columnsWidth.hsf}
      ${columnsWidth.dlw}
      ${columnsWidth.dlr}
      ${columnsWidth.extender}
    `
  }
});
